import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { motion } from "framer-motion";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import useBoolean from "@hooks/useBoolean";
import Story from "@componentsShared/Story/Story";
import PreCheckoutOptionsShimmer from "./PreCheckoutOptionsShimmer";
import FinanceModal from "./PurchaseMethods/FinanceModal";
import TabbyModal from "./PurchaseMethods/TabbyModal";
import TamaraModal from "./PurchaseMethods/TamaraModal";
import AmwalModal from "./PurchaseMethods/AmwalModal";
import PaymentSectionCard from "./PaymentSections/PaymentSectionCard";
import BnplGroupCard from "./PaymentSections/BnplGroupCard";
import CampaignModal from "@/pages/checkout/components/CampaignModal/CampaignModal";
import { trackEvents } from "@/common/events/events";
var PreCheckoutPaymentSectionsRenderer = function PreCheckoutPaymentSectionsRenderer(_ref) {
  var _salePrice$replace;
  var sections = _ref.sections,
    loading = _ref.loading,
    salePrice = _ref.salePrice,
    financeSteps = _ref.financeSteps,
    postIsNew = _ref.postIsNew,
    postId = _ref.postId,
    g4Data = _ref.g4Data,
    rejectionItems = _ref.rejectionItems,
    selectedSplitPaymentUrl = _ref.selectedSplitPaymentUrl,
    onSplitPaymentSelected = _ref.onSplitPaymentSelected,
    cashStory = _ref.cashStory;
  var financeModal = useCheckoutOrder().state.financeModal;
  var tabbyModal = useBoolean();
  var tamaraModal = useBoolean();
  var amwalModal = useBoolean();
  var cashStoryModal = useBoolean();
  var _useState = useState(null),
    activeCampaignModal = _useState[0],
    setActiveCampaignModal = _useState[1];
  var numericPrice = Number((_salePrice$replace = salePrice === null || salePrice === void 0 ? void 0 : salePrice.replace(/,/g, "")) !== null && _salePrice$replace !== void 0 ? _salePrice$replace : 0);
  if (loading || !(sections !== null && sections !== void 0 && sections.length)) return /*#__PURE__*/React.createElement(PreCheckoutOptionsShimmer, null);
  var handleInfoClick = function handleInfoClick(action) {
    var story_type = action.story_type;
    if (story_type === "tamara") return tamaraModal.setTrue();
    if (story_type === "tabby") return tabbyModal.setTrue();
    if (story_type === "credit_card" || story_type === "amwal") return amwalModal.setTrue();
    if (story_type === "finance") return financeModal.setTrue();
    if (story_type === "cash") return cashStoryModal.setTrue();
  };
  var handleCampaignClick = function handleCampaignClick(campaign, type) {
    var _campaign$info, _campaign$info2;
    trackEvents("marketing_theme_click", _objectSpread(_objectSpread({}, g4Data), {}, {
      has_timer: false,
      theme_type: type === "finance" ? "Finance" : "Cash"
    }));
    setActiveCampaignModal({
      title: campaign.lable,
      text: campaign.lable,
      desktop_image: (_campaign$info = campaign.info) === null || _campaign$info === void 0 ? void 0 : _campaign$info.desktop_image,
      description: (_campaign$info2 = campaign.info) === null || _campaign$info2 === void 0 ? void 0 : _campaign$info2.description
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, sections.map(function (section, idx) {
    return section.method_type === "bnpl" ? /*#__PURE__*/React.createElement(motion.div, {
      key: section.method_type,
      initial: {
        opacity: 0,
        y: 16
      },
      animate: {
        opacity: 1,
        y: 0
      },
      transition: {
        duration: 0.35,
        delay: idx * 0.07,
        ease: "easeOut"
      }
    }, /*#__PURE__*/React.createElement(BnplGroupCard, {
      section: section,
      selectedSplitPaymentUrl: selectedSplitPaymentUrl,
      onSplitPaymentSelected: onSplitPaymentSelected,
      rejectionItems: rejectionItems,
      onInfoClick: handleInfoClick
    })) : /*#__PURE__*/React.createElement(motion.div, {
      key: section.method_type,
      initial: {
        opacity: 0,
        y: 16
      },
      animate: {
        opacity: 1,
        y: 0
      },
      transition: {
        duration: 0.35,
        delay: idx * 0.07,
        ease: "easeOut"
      }
    }, /*#__PURE__*/React.createElement(PaymentSectionCard, {
      section: section,
      selectedSplitPaymentUrl: selectedSplitPaymentUrl,
      onSplitPaymentSelected: onSplitPaymentSelected,
      onInfoClick: handleInfoClick,
      onCampaignClick: handleCampaignClick
    }));
  }), /*#__PURE__*/React.createElement(FinanceModal, {
    isOpen: financeModal.value,
    onClose: financeModal.setFalse,
    isNew: !!postIsNew,
    postId: postId,
    financeSteps: financeSteps,
    g4Data: g4Data
  }), /*#__PURE__*/React.createElement(TabbyModal, {
    isOpen: tabbyModal.value,
    onClose: tabbyModal.setFalse,
    price: numericPrice
  }), /*#__PURE__*/React.createElement(TamaraModal, {
    isOpen: tamaraModal.value,
    onClose: tamaraModal.setFalse,
    amount: numericPrice
  }), /*#__PURE__*/React.createElement(AmwalModal, {
    isOpen: amwalModal.value,
    onClose: amwalModal.setFalse,
    price: numericPrice
  }), /*#__PURE__*/React.createElement(CampaignModal, {
    modalName: activeCampaignModal ? "campaign" : null,
    doClose: function doClose() {
      return setActiveCampaignModal(null);
    },
    campaignData: activeCampaignModal,
    isPostModal: false,
    dataFromPost: undefined
  }), cashStory && /*#__PURE__*/React.createElement(Story, {
    showStoryMode: cashStoryModal.value,
    closeStory: cashStoryModal.setFalse
  }, cashStory.data.map(function (story, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "singleStry",
      "data-color": "linear-gradient(180deg, ".concat(story.darkColor, " 0%, ").concat(story.lightColor, " 100%)")
    }, /*#__PURE__*/React.createElement("strong", {
      style: {
        textAlign: "center"
      }
    }, cashStory.title), /*#__PURE__*/React.createElement("img", {
      src: story.image,
      alt: "story"
    }));
  })));
};
export default PreCheckoutPaymentSectionsRenderer;